import actions from '../actions';
import { ASYNC_FETCH_INITIAL_STATE, makeAsyncFetchReducer, makeReducer } from '../utils';

const INITIAL_STATE = {
  companies: ASYNC_FETCH_INITIAL_STATE,
};

const reducer = makeReducer({
  initialState: INITIAL_STATE,
  reducers    : {
    ...makeAsyncFetchReducer({
      key    : 'companies',
      init   : actions.companies.fetch.type,
      success: actions.companies.fetchSuccess.type,
      error  : actions.companies.fetchError.type,
    }),
  },
});

export default reducer;
